import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Form, Formik, FormikErrors } from "formik";
import * as React from "react";
import ButtonGroup from "../../components/Buttons/ButtonGroup";
import ProgressIndicator from "../../components/ProgressIndicator";
import strings from "../../config/localization";
import { useNewDesignationMutation } from "../../services/appln";
import ErrorMsg from "../../components/ErrorMsg";

interface FormData {
  name: string;
  abbreviation: string;
}

interface Props {
  onSubmitHandler: (newObj: any) => void;
  onCancelHandler: () => void;
  state: boolean;
}

export default function NewDesignation(props: Props) {
  const [createDesignation, createDesignationParams] =
    useNewDesignationMutation();

  const iv: FormData = {
    name: "",
    abbreviation: "",
  };

  const onCancelHandlerWrapper = () => {
    createDesignationParams.reset();
    props.onCancelHandler();
  };

  console.log(
    "NewDesignation, createDesignationParams:",
    createDesignationParams,
  );
  React.useEffect(() => {
    if (createDesignationParams.isSuccess) {
      props.onSubmitHandler(createDesignationParams.data.id);
    }
  }, [createDesignationParams]);

  return (
    <div>
      <Dialog
        open={props.state}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {strings.newDesignation}
        </DialogTitle>
        {createDesignationParams.isError && (
          <ErrorMsg msg={strings.failedToCreateDesignation} />
        )}
        {createDesignationParams.isLoading && <ProgressIndicator />}
        <DialogContent>
          <Formik
            initialValues={iv}
            validate={(values) => {
              const errors: FormikErrors<FormData> = {};
              if (!values.name) {
                errors.name = strings.nameMandatory;
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(false);
              createDesignation(values);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form>
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        required
                        margin="normal"
                        id="name"
                        name="name"
                        label={strings.name}
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.name && Boolean(errors.name)}
                        helperText={touched.name && errors.name}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        margin="normal"
                        id="abbreviation"
                        name="abbreviation"
                        label={strings.abbreviation}
                        value={values.abbreviation}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          touched.abbreviation && Boolean(errors.abbreviation)
                        }
                        helperText={touched.abbreviation && errors.abbreviation}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      <ButtonGroup>
                        <Button
                          variant="contained"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          {strings.create}
                        </Button>
                        <Button
                          variant="contained"
                          onClick={onCancelHandlerWrapper}
                        >
                          {strings.cancel}
                        </Button>
                      </ButtonGroup>
                    </Grid>
                  </Grid>
                </Box>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </div>
  );
}
